import React from "react";
import Modal from "react-bootstrap/Modal";
import Spinner from "components/UI/Spinner.js";
import "./style.scss";

export default function StripeDisconnectModal({
  show,
  onHide,
  onSoftDisconnect,
  onPermanentDisconnect,
  isLoading = false
}) {
  return (
    <Modal show={show} onHide={onHide} className="stripe-disconnect-modal" centered>
      <Modal.Header disabled={isLoading}></Modal.Header>
      <Modal.Body>
        <div className="disconnect-modal-content">
          <h3>Disconnect Stripe Account</h3>
          <p className="disconnect-description">
            You are about to disconnect your Stripe account from iHunt.
          </p>
          
          <div className="disconnect-options">
            <div 
              className={`disconnect-option ${isLoading ? 'disabled' : ''}`} 
              onClick={isLoading ? undefined : onSoftDisconnect}
            >
              <div className="option-icon soft-disconnect">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#0566c8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                  <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
                </svg>
              </div>
              <div className="option-content">
                <h4>Soft Disconnect</h4>
                <p>Unlink your Stripe account but keep it saved. You can reconnect anytime without onboarding again.</p>
              </div>
            </div>

            <div 
              className={`disconnect-option ${isLoading ? 'disabled' : ''}`} 
              onClick={isLoading ? undefined : onPermanentDisconnect}
            >
              <div className="option-icon permanent-disconnect">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#dc3545" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="3,6 5,6 21,6"></polyline>
                  <path d="M19,6v14a2,2 0 0,1 -2,2H7a2,2 0 0,1 -2,-2V6m3,0V4a2,2 0 0,1 2,-2h4a2,2 0 0,1 2,2v2"></path>
                  <line x1="10" y1="11" x2="10" y2="17"></line>
                  <line x1="14" y1="11" x2="14" y2="17"></line>
                </svg>
              </div>
              <div className="option-content">
                <h4>Disconnect & Forget</h4>
                <p>Remove your Stripe account permanently. Reconnecting will require creating a new Stripe account.</p>
              </div>
            </div>
          </div>

          <div className="modal-actions">
            <button 
              type="button" 
              className="btn btn-link cancel-btn" 
              onClick={onHide}
              disabled={isLoading}
            >
              Cancel
            </button>
          </div>

          {isLoading && (
            <div className="loading-overlay">
              <div className="loading-content">
                <Spinner />
                <p>Disconnecting your Stripe account...</p>
              </div>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}
